<template>
  <div class="flock-card" :class="[hasRead && 'flock-card-read', isAndroid && 'flock-card-android']" @click="cardClick">
    <FlockCardHeader :info="info" @menuClick="menuClick" />
    <!-- 单图内容 -->
    <div class="flock-card-1" v-if="info.item_type === 'f_1' && !info.link_info">
      <div class="g-card-title flock-card-1-title text-clamp">{{info.title || info.content}}</div>
      <img class="half-pixel-border" :src="info.show_info.medias_list[0].src" />
    </div>
    <!-- 大图内容 -->
    <div class="flock-card-1-b" v-else-if="info.item_type === 'f_1_m' || info.item_type === 'f_1_b'">
      <div class="flock-card-1-b-title g-card-title text-clamp">{{info.title || info.content}}</div>
      <VideoComp
        v-if="info.video_info.url"
        :videoSrc="info.video_info.url"
        :coverSrc="info.video_info.pic_url"
        :showVideo="videoActiveIndex === index"
        :videoId="'video' + index"
        :index="index"
        :duration="info.video_info.video_label"
        @vCompClick="videoClick"
        bind:vCompFullScreenChange="fullScreenChange"
      />
      <div class="flock-card-1-b-img" v-else >
        <img class="half-pixel-border flock-card-1-b-media" :src="info.show_info.medias_list[0].src" />
        <span v-if="info.show_info.medias_list.length > 1">1/{{info.show_info.medias_list.length}}</span>
      </div>
    </div>
    <!-- 文字内容 -->
    <div class="g-card-title flock-card-txt text-clamp" v-else-if="info.item_type === 'f_txt' && !info.link_info">
      {{info.content || info.title}}
    </div>
    <!-- 链接 -->
    <div v-else-if="(info.item_type === 'f_1' || info.item_type === 'f_txt') && info.link_info" class="flock-card-link">
      <span class="flock-card-link-indicator"></span>
      <div
        class="flock-card-link-content"
        :style="{ 'max-height': info.readMore ? 'auto' : '120rpx', 'padding-bottom': info.readMore ? '48rpx' : '' }"
        v-if="info.content || info.titl"
      >
        <div class="flock-card-link-txt text-clamp">{{info.content || info.title}}</div>
        <!-- <div
          class="flock-card-link-more"
          :style="info.readMore ? { bottom: 0 } : { top: '94rpx'}"
          catchtap="toggleReadMore"
        >
          {{info.readMore ? '收起' : '...全文'}}
        </div> -->
      </div>
      <div class="flock-card-1">
        <div class="g-card-title flock-card-1-title text-clamp">{{info.link_info.title}}</div>
        <img v-if="info.link_info.thumb_url" class="half-pixel-border" :src="info.link_info.thumb_url" />
      </div>
    </div>
    <!-- 三图内容 -->
    <div class="flock-card-3" v-else>
      <div class="g-card-title flock-card-3-title text-clamp">{{info.title}}</div>
      <div class="flock-card-3-images">
        <img v-for="(item, index) in '123'" :key="index" class="half-pixel-border" :src="info.show_info.medias_list[index].src" />
      </div>
    </div>
    <flock-card-footer :info="info" :localLikeStatus="localLikeStatus" @likeClick="likeClick"/>
  </div>
</template>

<script>
import FlockCardHeader from'./FlockCardHeader'
import FlockCardFooter from'./FlockCardFooter'
import VideoComp from'./VideoComp'

export default {
  name: 'FlockCard',
  props: {
    info: {
      type: Object,
      default: () => ({
        show_info: {
          medias_list: [{}]
        }
      })
    },
    isAndroid: {
      type: Boolean,
      default: false
    },
    videoActiveIndex: {
      type: Number,
      default: -1
    },
    hasRead: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    localLikeStatus: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: -1
    }
  },
  components: {
    FlockCardHeader,
    FlockCardFooter,
    VideoComp
  },
  methods: {
    videoClick () {
      this.$emit('videoClick', { index: this.index })
    },
    cardClick (pk, open_type) {
      this.$emit('cardClick', { url: this.info.weburl, pk, open_type })
    },
    likeClick () {
      this.$emit('likeClick')
    },
    menuClick () {
      this.$emit('menuClick')
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../mixins.less);

.flock-card{
  display: block;
}

.flock-card-read{
  .g-card-title{
    color: rgb(171, 171, 171);
  }
}

.flock-card-1{
  .flex();
  img{
    .webkitCss(flex, 0 0 auto);
    width:224 / @ratio;
    height:148 / @ratio;
    margin-left: 32 / @ratio;
    border-radius:12 / @ratio;
    .webkitCss(object-fit, cover);
    .webkitCss(object-position, center);
    &::before{
      border-radius: 24 / @ratio;
    }
  }
}

.flock-card-1-title{
  .webkitCss(flex, 1 1 auto);
  // margin-bottom: 16 / @ratio;
  line-height:50 / @ratio;
  -webkit-line-clamp:3; 
}

.flock-card-txt.g-card-title{
  line-height: 44 / @ratio;
}


.flock-card-1-b-media{
  width: 670 / @ratio;
  height: 416 / @ratio;
  border-radius: 12 / @ratio;
  .webkitCss(object-fit, cover);
  .webkitCss(object-position, center);
  &::before{
    border-radius: 24 / @ratio;
  }
}

.flock-card-1-b-img {
  position: relative;
  span{
    position: absolute;
    right: 32 / @ratio;
    top: 32 / @ratio;
    height: 44 / @ratio;
    padding: 0 16 / @ratio;
    font-size:24 / @ratio;
    font-weight: bold;
    color:rgba(255,255,255,1);
    line-height:44 / @ratio;
    background:rgba(0,0,0,0.75);
    border-radius:22 / @ratio;
  }
}

.flock-card-1-b-title {
  margin-bottom: 16 / @ratio;
}

.flock-card-3-title{
  line-height: 44 / @ratio;
  -webkit-line-clamp: 2;
}
.flock-card-3-images{
  margin-top: 20 / @ratio;
  img{
    width: 216  / @ratio;
    height: 140 / @ratio;
    border-radius: 12 / @ratio;
    object-fit: cover;
    object-position: center;
    &::before{
      border-radius: 24 / @ratio;
    }
  }
  img:nth-child(1), & img:nth-child(2){
    margin-right: 10 / @ratio;
  }
}

.flock-card-link-content{
  position: relative;
  width: max-content;
  width: -webkit-max-content;
  max-width: 670 / @ratio;
  margin-left: -12 / @ratio;
  margin-bottom: 24 / @ratio;
  padding: 12 / @ratio;
  overflow: hidden;
  background:rgba(247,247,247,1);
  border-radius:12 / @ratio;
  div{
    font-size:28 / @ratio;
    line-height:40 / @ratio;
  }
  .flock-card-link-txt{
    height: auto;
    color:rgba(51,51,51,1);
    -webkit-line-clamp: 2;
  }
  // .flock-card-link-more{
  //   position: absolute;
  //   left: 12 / @ratio;
  //   width: 670 / @ratio;
  //   height: 50 / @ratio;
  //   padding-top: 3 / @ratio;
  //   color: #7586A8;
  //   background:rgba(247,247,247,1);
  // }
}
.flock-card-link-indicator{
  display: block;
  width: 0;
  height: 0;
  margin-top: -25 / @ratio;
  border-bottom: 14 / @ratio solid rgba(247,247,247,1);
  border-left: 8 / @ratio solid transparent;
  border-right: 8 / @ratio solid transparent;
}
</style>
